import React, { PureComponent } from "react";
import { get, isEmpty } from "lodash";
import build from "redux-object";
import { connect } from "react-redux";

import { fetchTemplate, updateTemplate } from "../../actions/templates.actions";
import { fetchUnfilteredBundles } from "../../actions/bundles.actions";
import { fetchUnfilteredLicenseBundles } from "../../actions/license-bundles.actions";
import { fetchUnfilteredFeatures } from "../../actions/features.actions";
import { getResourceById } from "../../reducers/resources.reducer";
import TemplateForm from "./TemplateForm";

class EditTemplate extends PureComponent {
  componentDidMount() {
    const { id } = this.props.match.params;

    this.props.dispatch(fetchTemplate(id));
    this.props.dispatch(fetchUnfilteredBundles());
    this.props.dispatch(fetchUnfilteredLicenseBundles());
    this.props.dispatch(fetchUnfilteredFeatures());
  }

  saveTemplateChanges = ({ template, templatesFeatures, templatesBundles, templatesLicenseBundles }) => {
    const { id } = template;
    this.props.dispatch(updateTemplate(id, { template, templatesFeatures, templatesBundles, templatesLicenseBundles }));
  };

  isRenderBundles = () => {
    return !isEmpty(this.props.bundles) && this.props.template.templatesBundles;
  };

  isRenderFeatures = () => {
    return !isEmpty(this.props.features) && this.props.template.templatesFeatures;
  };

  isRenderLicenseBundles = () => {
    return !isEmpty(this.props.licenseBundles) && this.props.template.templatesLicenseBundles;
  };

  render() {
    return (
      <TemplateForm
        saveTemplateChanges={this.saveTemplateChanges}
        isRenderFeatures={this.isRenderFeatures}
        isRenderBundles={this.isRenderBundles}
        isRenderLicenseBundles={this.isRenderLicenseBundles}
        {...this.props}
        page="Edit"
      />
    );
  }
}

const mapStateToProps = (state, props) => {
  const { id } = props.match.params;

  return {
    template: getResourceById(state, id),
    bundles: build(get(state, "bundles.bundles", {}), "bundles", null, {
      ignoreLinks: true
    }),
    licenseBundles: build(get(state, "licenseBundles.licenseBundles", {}), "licenseBundles", null, {
      ignoreLinks: true
    }),
    features: build(get(state, "features.features", {}), "productMetadataTypes", null, {
      ignoreLinks: true
    })
  };
};
export default connect(mapStateToProps)(EditTemplate);
